import { render, staticRenderFns } from "./CompanyNotice.vue?vue&type=template&id=d5c5e48c&scoped=true"
import script from "./CompanyNotice.vue?vue&type=script&lang=js"
export * from "./CompanyNotice.vue?vue&type=script&lang=js"
import style0 from "./CompanyNotice.vue?vue&type=style&index=0&id=d5c5e48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c5e48c",
  null
  
)

export default component.exports